<template>
  <v-app class="dt-theme" :class="appThemeClass">
    <v-navigation-drawer
      persistent
      :mini-variant="miniVariant"
      :clipped="clipped"
      :value="appDrawer"
      stateless
      :width="200"
      disable-resize-watcher
      fixed
      app
    >
      <div
        v-for="item of items"
        :key="item.route"
        @click="(e) => onItemClick(item)"
      >
        <div class="ut-link ut-text-accent5">
          {{ item.name }}
        </div>
      </div>
    </v-navigation-drawer>
    <v-content
      :class="{
        'module-container': true,
      }"
    >
      <v-layout class="dt-module-container" column align-center>
        <v-container fluid class="dt-module">
          <router-view />
        </v-container>
      </v-layout>
    </v-content>
  </v-app>
</template>

<script>
import { PlaygroundRouter } from "./router";

export default {
  components: {},
  data() {
    return {
      appThemeClass: {
        light: true,
      },
      clipped: false,
      fixed: false,
      miniVariant: false,
      right: true,
      rightDrawer: false,
      appDrawer: true,

      items: PlaygroundRouter.children,
    };
  },
  methods: {
    isModuleActive: function (route, item) {
      const routePattern = new RegExp(
        `/${this.base}/${item.route.toLowerCase()}`,
        "ig"
      );
      const isMatch = routePattern.exec(route.path);
      return isMatch;
    },
    onItemClick(item) {
      console.log({ "item.path": item.path });
      this.$router.push({
        path: `/playground/${item.path}`,
      });
    },
    //MARK: Methods
  },
};
</script>

